import React from 'react';
import RetentionRuleDetailSection from '../../../sections/AdminDashboard/Configuration/RetentionRuleDetail';

const RetentionRuleDetail = () => <RetentionRuleDetailSection />;

export default RetentionRuleDetail;
